__turbopack_context__.v({
  "brandBackground": "-LzqAG_brandBackground",
  "brandDescription": "-LzqAG_brandDescription",
  "brandOutlineButton": "-LzqAG_brandOutlineButton",
  "brandPrimaryButton": "-LzqAG_brandPrimaryButton",
  "darkBackground": "-LzqAG_darkBackground",
  "onDarkDescription": "-LzqAG_onDarkDescription",
  "primaryButton": "-LzqAG_primaryButton",
  "textureOverlay": "-LzqAG_textureOverlay",
});
